import { listPaymentMethods, addPaymentMethod, setDefaultPaymentMethod, deletePaymentMethod } from '@/services/paymentMethodsService'

var TTL_MS = 5 * 60 * 1000

function isFresh (ts) {
  return ts && (Date.now() - ts) < TTL_MS
}

export default {
  namespaced: true,
  state: function () {
    return {
      items: [],
      loading: false,
      lastFetched: null
    }
  },
  getters: {
    ALL: function (state) { return state.items }
  },
  mutations: {
    SET_ITEMS: function (state, items) { state.items = items },
    SET_LOADING: function (state, val) { state.loading = val },
    SET_LAST_FETCHED: function (state) { state.lastFetched = Date.now() },
    ADD_ITEM: function (state, item) {
      state.items = state.items.concat([item])
    },
    REMOVE_ITEM: function (state, id) {
      state.items = state.items.filter(function (pm) { return pm.id !== id })
    },
    SET_DEFAULT: function (state, id) {
      state.items = state.items.map(function (pm) {
        return Object.assign({}, pm, { isDefault: pm.id === id })
      })
    }
  },
  actions: {
    FETCH: function (context, opts) {
      var force = opts && opts.force
      if (!force && isFresh(context.state.lastFetched) && context.state.items.length > 0) {
        return Promise.resolve()
      }
      context.commit('SET_LOADING', true)
      return listPaymentMethods().then(function (methods) {
        context.commit('SET_ITEMS', Array.isArray(methods) ? methods : [])
        context.commit('SET_LAST_FETCHED')
        context.commit('SET_LOADING', false)
      }).catch(function (err) {
        context.commit('SET_LOADING', false)
        return Promise.reject(err)
      })
    },
    ADD: function (context, payload) {
      return addPaymentMethod(payload).then(function (pm) {
        context.commit('ADD_ITEM', pm)
        if (context.state.items.length === 1) {
          context.commit('SET_DEFAULT', pm.id)
        }
        return pm
      })
    },
    SET_DEFAULT: function (context, id) {
      return setDefaultPaymentMethod(id).then(function () {
        context.commit('SET_DEFAULT', id)
      })
    },
    DELETE: function (context, id) {
      return deletePaymentMethod(id).then(function () {
        context.commit('REMOVE_ITEM', id)
      })
    }
  }
}
